<div class="main">


    <div class="header">
        <div class="title">
            <div class="label">
                Emails </div>
            <!-- <div class="help">
                <app-help [helpData]="helpData"></app-help>
            </div> -->
        </div>
    </div>

    <div class="filters">
        <div class="input">
            <input type="text" class="inputField" placeholder="From" (click)="fromDateInput1.open()"
                [matDatepicker]="fromDateInput1" [(ngModel)]="fromDate" />
            <mat-datepicker #fromDateInput1 (closed)="getEmails()"></mat-datepicker>
            <span class="material-icons dateIcon">
                <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
        </div>
        <div class="input">
            <input type="text" class="inputField" placeholder="To" (click)="toDateInput1.open()"
                [matDatepicker]="toDateInput1" [(ngModel)]="toDate" />
            <mat-datepicker #toDateInput1 (closed)="getEmails()"></mat-datepicker>
            <span class="material-icons dateIcon">
                <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
        </div>
    </div>
    <div class="tableSection">
        <ng-template #noVendors>
            <div class="noVendors">
                {{ "SUPPORTDETAILS.noVendorsFound" | translate }}
            </div>
        </ng-template>
        <table mat-table [dataSource]="supportDetails" matSort class="loadTable" *ngIf="isdata;else noData">

            <ng-container matColumnDef="slno">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                    {{ "Sl.no" | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                </td>
            </ng-container>

            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                    Subject </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.payload.subject }}
                </td>
            </ng-container>

            <ng-container matColumnDef="template">
                <th mat-header-cell *matHeaderCellDef class="customHeader" style="width:500px;">
                    Template </th>
                <td mat-cell *matCellDef="let element">
                    <div style="width:450px;">{{ element.payload.template }}</div>

                </td>
            </ng-container>

            <ng-container matColumnDef="to">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                    To </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.payload.to }}

                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                    Status </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.status }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"
                style="font-weight: bold !important; height: 50px"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns; let i = index"
                style="font-family: 'Muli', sans-serif"></tr>
        </table>
    </div>
</div>

<ng-template #noData>
    <div class="noAdvice">
        No Data Found.
    </div>
</ng-template>